module.exports = __webpack_public_path__ + "static/scene-digital-2-603c4b81a20973b638ec4f7b0aa064b7.png";